import { render, staticRenderFns } from "./ImportExport.vue?vue&type=template&id=1225f734&"
import script from "./ImportExport.vue?vue&type=script&lang=ts&"
export * from "./ImportExport.vue?vue&type=script&lang=ts&"
import style0 from "./ImportExport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports